import React from "react";
import QrCodePayment from "./QrCodePayment";

const QrCode = () => {
  return (
    <div class="mx-auto mb-5">
      <QrCodePayment />
    </div>
  );
};

export default QrCode;
